import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import Slider from "react-slick";
import "react-toastify/dist/ReactToastify.css";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import useSWR from "swr";
import { fetcher } from "../../../../lib/config";
import Loader from "../../../elements/Loader";
import Container from "../../../shared/Container";
import TwinCard from "./TwinCard";
import { Carousel } from "./styles";
import axios from "axios";
import { useEffect, useState } from 'react';
import endpoints from "../../../../utility/endpoints";
const NextArrow = ({ onClick }) => (
  <div onClick={onClick} className={`nextArrow cursor-pointer`}>
    <AiOutlineArrowRight className="bg-main md:bg-[#508AC1] md:bg-opacity-50 text-white md:text-black h-8 w-8 rounded-full p-2" />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div onClick={onClick} className={`prevArrow cursor-pointer`}>
    <AiOutlineArrowLeft className="bg-main md:bg-[#508AC1] md:bg-opacity-50 text-white md:text-black h-8 w-8 rounded-full p-2" />
  </div>
);

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  lazyLoad: "ondemand",
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const TwinBots = ({ botId, headerName = "Employee Twin", showCloneBtn = true }) => {
  //const { data, error, isLoading } = useSWR("elastic/searchQueryTwin", fetcher);
 const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
const fetchData = async () => {
  try {
    const authData = JSON.parse(localStorage.getItem("auth"));
    if (authData && authData.data && authData.data.accessToken) {
      const auth = authData.data;
      const response = await axios({
        method: "get",
        url: `${endpoints.baseUrl}/elastic/searchQueryTwin`,
        headers: {
          Authorization: auth.accessToken,
        },
      });

      // Extract the data from the response
      const { data } = response;

      return data;
    } else {
      // Handle the case where 'auth.accessToken' is missing in 'localStorage'
      console.error("Authentication data is missing or incomplete.");
    }
  } catch (error) {
    // Handle any request errors here
    console.error("Request error:", error);
    throw error;
  }
};

 useEffect(() => {
    fetchData()
      .then((responseData) => {
        setData(responseData);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);
  return (
    <div id="twinBots">
      <Container className="py-10 md:py-16">
        <h3 className="text-4xl text-center mb-12 text-main font-medium">{headerName}</h3>

    {/*    {(error || data?.success == false) && <h4 className="text-center text-2xl font-medium uppercase">Failed to fetch Twins</h4>}

        {isLoading && (
          <div className="text-center my-5">
            <Loader />
          </div>
        )}

        <Carousel>
          {!error && data?.data?.allTwinBots?.length ? (
            <Slider {...settings}>
              {data?.data?.allTwinBots
                ?.filter((item) => item._source.employeeTwinID != botId)
                .map((twin, index) => (
                 twin?._source?.employeeTwinName.length? 
                 <TwinCard twin={twin} key={index} showCloneBtn={showCloneBtn} />
	         :null
                ))}
            </Slider>
          ) : null}
        </Carousel>*/}
{loading && (
          <div className="text-center my-5">
            <p>Loading...</p>
          </div>
        )}

        {error && (
          <div className="text-center my-5">
            <p>Error fetching data. Please try again later.</p>
          </div>
        )}

        {!loading && !error && data?.data?.allTwinBots?.length ? (
          <Carousel>
            <Slider {...settings}>
              {data?.data?.allTwinBots
                ?.filter((item) => item._source.employeeTwinID !== botId)
                .map((twin, index) => (
                 twin?._source?.employeeTwinName.length?
                  <TwinCard twin={twin} key={index} showCloneBtn={showCloneBtn} />
                 :null
                ))}
            </Slider>
          </Carousel>
        ) : null}
      </Container>
    </div>
  );
};

export default TwinBots;

